export function makeRows (context) {
  console.log('makeRows', context)

  const rows = context.data?.monthlyValues?.map(function (oneValue) {
    const row = {
      ...oneValue
    }

    row.amount = parseFloat(row.amount)
    row.balance = parseFloat(row.balance)
    row.count = parseInt(row.count)

    return row
  })

  // return context.data?.monthlyValues
  return rows
}
